import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BookmarkIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M17 2H7C5.3 2 4 3.3 4 5v16c0 .4.2.7.5.9.3.2.7.1 1-.1l6.4-4.6 6.4 4.6c.2.1.4.2.6.2.2 0 .3 0 .5-.1.3-.2.5-.5.5-.9V5c.1-1.7-1.2-3-2.9-3zm1 17.1l-5.4-3.9c-.2-.1-.4-.2-.6-.2-.2 0-.4.1-.6.2L6 19.1V5c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v14.1z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
BookmarkIcon.isCarinaIcon = true;
export default BookmarkIcon;
